module.exports = __webpack_public_path__ + "img/payment_status.449f3eb5.svg";